import React from 'react';
import { Stack, Container, Typography } from '@mui/material';
import MobileHidden from 'components/MobileHidden';
import LoginForm from 'components/LoginForm';
import { RootStyle, SectionStyle, ContentStyle, LogoBox } from './style';

export function Login() {
  return (
    <RootStyle title='Login | Minimal-UI'>
      <LogoBox>
        <img src='/logo-horizontal.png' alt='logo' />
      </LogoBox>
      <MobileHidden width='mdDown'>
        <SectionStyle>
          <img src='/500.png' alt='500' />
        </SectionStyle>
      </MobileHidden>

      <Container maxWidth='sm'>
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant='h4'>Gymwork Admin</Typography>
          </Stack>

          <LoginForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
